import App from "@/App";

import React from "react";

import "@configs/i18n";
import {InfoPopup} from "@layouts/popup/InfoPopup";
import {PopupProvider} from "@layouts/popup/InfoPopup/PopupContext";
import {store} from "@redux/store";
import "core-js/stable";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import "regenerator-runtime/runtime";

const rootElem = document.getElementById("root");

if (rootElem) {
  const root = ReactDOM.createRoot(rootElem);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path={"*"}
        element={
          <>
            <App />
            <InfoPopup
              width={794}
              close
            />
          </>
        }
      />,
    ),
  );

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PopupProvider>
          <RouterProvider router={router} />
        </PopupProvider>
      </Provider>
    </React.StrictMode>,
  );
}
